// extracted by mini-css-extract-plugin
export default {"container":"CroppedImageModal_container__ZR5Wn","rangeContainer":"CroppedImageModal_rangeContainer__Ua5Nn"};